export function mapWebhookToUpdate(webhook: App.IWebhook) {
  return {
    path: webhook.path,
    name: webhook.name,
    contentType: webhook.contentType,
    eventIdFieldName: webhook.eventIdFieldName,
    persistentFields: webhook.persistentFields,
    accountIdFieldName: webhook.accountIdFieldName,
    failReasonFieldName: webhook.failReasonFieldName
  }
}
